export enum GroupActionTypes {
    FETCH_GROUP_MEETING_STARTED = 'GROUP/FETCH_GROUP_MEETING_STARTED',
    FETCH_GROUP_MEETING_COMPLETED = 'GROUP/FETCH_GROUP_MEETING_COMPLETED',
    FETCH_GROUP_MEETING_FAILED = 'GROUP/FETCH_GROUP_MEETING_FAILED',
    FETCH_GROUP_MEETINGS_STARTED = 'GROUP/FETCH_GROUP_MEETINGS_STARTED',
    FETCH_GROUP_MEETINGS_COMPLETED = 'GROUP/FETCH_GROUP_MEETINGS_COMPLETED',
    FETCH_GROUP_MEETINGS_FAILED = 'GROUP/FETCH_GROUP_MEETINGS_FAILED',
    FETCH_GROUP_MEMBERS_STARTED = 'GROUP/FETCH_GROUP_MEMBERS_STARTED',
    FETCH_GROUP_MEMBERS_COMPLETED = 'GROUP/FETCH_GROUP_MEMBERS_COMPLETED',

    FETCH_GROUP_ACTIVITYSTATS_COMPLETED = 'GROUP/FETCH_GROUP_ACTIVITYSTATS_COMPLETED',
    FETCH_GROUP_ACTIVITYSTATS_FAILED = 'GROUP/FETCH_GROUP_ACTIVITYSTATS_FAILED',

    FETCH_GROUP_MEMBERS_FAILED = 'GROUP/FETCH_GROUP_MEMBERS_FAILED',
    FETCH_GROUP_MESSAGES_STARTED = 'GROUP/FETCH_GROUP_MESSAGES_STARTED',
    FETCH_GROUP_MESSAGES_COMPLETED = 'GROUP/FETCH_GROUP_MESSAGES_COMPLETED',
    FETCH_GROUP_MESSAGES_FAILED = 'GROUP/FETCH_GROUP_MESSAGES_FAILED',
    FETCH_GROUPS_STARTED = 'GROUP/FETCH_GROUPS_STARTED',
    FETCH_GROUPS_COMPLETED = 'GROUP/FETCH_GROUPS_COMPLETED',
    FETCH_GROUPS_FAILED = 'GROUP/FETCH_GROUPS_FAILED',
    GET_GROUP_STARTED = 'GROUP/GET_GROUP_STARTED',
    GET_GROUP_COMPLETED = 'GROUP/GET_GROUP_COMPLETED',
    GET_GROUP_FAILED = 'GROUP/GET_GROUP_FAILED',
    SET_CURRENT_GROUP = 'GROUP/SET_CURRENT_GROUP',
    REMOVE_MEETING_DOCUMENT_STARTED = 'GROUP/REMOVE_MEETING_DOCUMENT_STARTED',
    REMOVE_MEETING_DOCUMENT_COMPLETED = 'GROUP/REMOVE_MEETING_DOCUMENT_COMPLETED',
    REMOVE_MEETING_DOCUMENT_FAILED = 'GROUP/REMOVE_MEETING_DOCUMENT_FAILED',
    SIGNUP_PERSON_STARTED = 'GROUP/SIGNUP_PERSON_STARTED',
    SIGNUP_PERSON_COMPLETED = 'GROUP/SIGNUP_PERSON_COMPLETED',
    SIGNUP_PERSON_FAILED = 'GROUP/SIGNUP_PERSON_FAILED',
    CANCEL_PERSON_STARTED = 'GROUP/CANCEL_PERSON_STARTED',
    CANCEL_PERSON_COMPLETED = 'GROUP/CANCEL_PERSON_COMPLETED',
    CANCEL_PERSON_FAILED = 'GROUP/CANCEL_PERSON_FAILED',
    ADD_FAVORITE_ATTACHMENT_STARTED = 'GROUP/ADD_FAVORITE_ATTACHMENT_STARTED',
    ADD_FAVORITE_ATTACHMENT_COMPLETED = 'GROUP/ADD_FAVORITE_ATTACHMENT_COMPLETED',
    ADD_FAVORITE_ATTACHMENT_FAILED = 'GROUP/ADD_FAVORITE_ATTACHMENT_FAILED',
    REMOVE_FAVORITE_ATTACHMENT_STARTED = 'GROUP/REMOVE_FAVORITE_ATTACHMENT_STARTED',
    REMOVE_FAVORITE_ATTACHMENT_COMPLETED = 'GROUP/REMOVE_FAVORITE_ATTACHMENT_COMPLETED',
    REMOVE_FAVORITE_ATTACHMENT_FAILED = 'GROUP/REMOVE_FAVORITE_ATTACHMENT_FAILED',
    ADD_FAVORITE_DOCUMENT_STARTED = 'GROUP/ADD_FAVORITE_DOCUMENT_STARTED',
    ADD_FAVORITE_DOCUMENT_COMPLETED = 'GROUP/ADD_FAVORITE_DOCUMENT_COMPLETED',
    ADD_FAVORITE_DOCUMENT_FAILED = 'GROUP/ADD_FAVORITE_DOCUMENT_FAILED',
    REMOVE_FAVORITE_DOCUMENT_STARTED = 'GROUP/REMOVE_FAVORITE_DOCUMENT_STARTED',
    REMOVE_FAVORITE_DOCUMENT_COMPLETED = 'GROUP/REMOVE_FAVORITE_DOCUMENT_COMPLETED',
    REMOVE_FAVORITE_DOCUMENT_FAILED = 'GROUP/REMOVE_FAVORITE_DOCUMENT_FAILED'
}